import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const previewLead = async (website) => {
  const res = await api.post("/lead/preview", { website });
  return res.data;
};

export const finalizeLead = async (draftId, email, voice) => {
  const payload = { draft_id: draftId, email };
  if (voice) payload.voice = voice;
  const res = await api.post("/lead", payload);
  return res.data;
};

// Backward compat (vecchio flow tutto-in-uno)
export const createLead = async (website, email, voice) => {
  const payload = { website, email };
  if (voice) payload.voice = voice;
  const res = await api.post("/lead", payload);
  return res.data;
};

export const getDemo = async (sessionId) => {
  const res = await api.get(`/demo/${sessionId}`);
  return res.data;
};

export const sendChat = async (sessionId, text, opts = {}) => {
  const res = await api.post(`/demo/${sessionId}/chat`, {
    text,
    text_only: !!opts.textOnly,
  });
  return res.data;
};

export const transcribeAudio = async (sessionId, blob) => {
  const formData = new FormData();
  formData.append("audio", blob, "audio.webm");
  const res = await axios.post(`${API}/demo/${sessionId}/transcribe`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const endDemo = async (sessionId) => {
  const res = await api.post(`/demo/${sessionId}/end`);
  return res.data;
};

export const endChatDemo = async (sessionId) => {
  const res = await api.post(`/demo/${sessionId}/chat-end`);
  return res.data;
};

export const submitActivation = async (data) => {
  const res = await api.post("/activation-request", data);
  return res.data;
};

export const dashboardLookup = async (email) => {
  const res = await api.get(`/dashboard/lookup?email=${encodeURIComponent(email)}`);
  return res.data;
};

export const dashboardSessionDetail = async (sessionId, email) => {
  const res = await api.get(`/dashboard/session/${sessionId}?email=${encodeURIComponent(email)}`);
  return res.data;
};


export const dashboardProLogin = async (slug, password) => {
  const res = await api.post(`/dashboard-pro/${slug}/login`, { password });
  return res.data;
};

export const dashboardProCalls = async (slug, token, page = 1) => {
  const res = await api.get(`/dashboard-pro/${slug}/calls?page=${page}&per_page=50`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const dashboardProCallDetail = async (slug, callId, token) => {
  const res = await api.get(`/dashboard-pro/${slug}/calls/${callId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const dashboardProMarkDone = async (slug, callId, token) => {
  const res = await api.patch(`/dashboard-pro/${slug}/calls/${callId}/done`, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const dashboardProDeleteCall = async (slug, callId, token) => {
  const res = await api.delete(`/dashboard-pro/${slug}/calls/${callId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const dashboardProStats = async (slug, token) => {
  const res = await api.get(`/dashboard-pro/${slug}/stats`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const dashboardProWallet = async (slug, token) => {
  const res = await api.get(`/dashboard-pro/${slug}/wallet`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const dashboardProGetSettings = async (slug, token) => {
  const res = await api.get(`/dashboard-pro/${slug}/settings`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const dashboardProUpdateSettings = async (slug, token, settings) => {
  const res = await api.patch(`/dashboard-pro/${slug}/settings`, settings, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const dashboardProListKnowledge = async (slug, token) => {
  const res = await api.get(`/dashboard-pro/${slug}/knowledge`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const dashboardProUploadKnowledge = async (slug, token, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await axios.post(`${API}/dashboard-pro/${slug}/knowledge`, formData, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const dashboardProDeleteKnowledge = async (slug, token, docId) => {
  const res = await api.delete(`/dashboard-pro/${slug}/knowledge/${docId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const saveCartesiaTranscript = async (sessionId, role, content) => {
  try {
    await api.post(`/demo/${sessionId}/cartesia/transcript`, { role, content });
  } catch (e) {
    // non bloccante
  }
};

export const adminDemoLeadsList = async (secret, page = 1) => {
  const res = await api.get(`/admin/demo-leads?secret=${encodeURIComponent(secret)}&page=${page}&per_page=30`);
  return res.data;
};

export const adminDemoLeadDetail = async (secret, sessionId) => {
  const res = await api.get(`/admin/demo-leads/${sessionId}?secret=${encodeURIComponent(secret)}`);
  return res.data;
};
